// extracted by mini-css-extract-plugin
var _1 = "BirdviewHomeRow-modulebody__erTm7";
var _2 = "BirdviewHomeRow-modulecontact__ZuZWt";
var _3 = "BirdviewHomeRow-moduleicon__HiH0l";
var _4 = "BirdviewHomeRow-modulelink__EH8qd";
var _5 = "BirdviewHomeRow-modulerow__QAt3P";
var _6 = "BirdviewHomeRow-modulevalue__bycGO";
export { _1 as "body", _2 as "contact", _3 as "icon", _4 as "link", _5 as "row", _6 as "value" }
